import { useIntl } from '@weenat/wintl';
import isNil from 'lodash-es/isNil';
import { useClient } from '../../ClientProvider';
import { usePlotDevicesIds } from '../../hooks';
import useMutation from '../../useMutation';
const usePlotsLinkedToDeviceActions = ({ device, plot, canEdit, onError, onSuccess }) => {
    const { t } = useIntl();
    const client = useClient();
    const deviceIds = usePlotDevicesIds(plot);
    const [updateDevices, updateDevicesRequest] = useMutation(client.plots.updateDevices(plot?.id), {
        onSuccess,
        onError
    });
    const actions = [
        {
            id: 'view_plot',
            label: t('models.plot.actions.view_plot', { capitalize: true }),
            to: `/farms/${plot?.organizationId}/admin/org-plots/${plot?.id}`,
            iconName: 'Preview'
        }
    ];
    if (canEdit) {
        actions.push({
            id: 'remove_from_plot',
            label: t('models.device.actions.remove_from_plot', { capitalize: true }),
            onPress: async () => {
                if (!isNil(deviceIds)) {
                    const newDevices = deviceIds.filter((id) => id !== device?.id) ?? [];
                    await updateDevices({ deviceIds: newDevices });
                }
            },
            state: updateDevicesRequest,
            iconName: 'Bin',
            needConfirmation: true
        });
    }
    return {
        actions
    };
};
export default usePlotsLinkedToDeviceActions;
